export const PAGE_CARD_SX = {
  backgroundColor: '#fff',
  borderRadius: 4,
  p: 3,
  mt: 3,
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  border: '1px solid #f1f5f9',
} as const;
